export default __webpack_public_path__ + "static/SRF 3355ACS50 - Fiche de spécifications et données techniques-b60699b8e90832e6b1ce7c6b53503f8b.pdf";